var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{ref:"api-settings-table",attrs:{"border":true,"show-header":false,"data":_vm.arrayApis,"highlight-current-row":"","size":"mini"},on:{"row-click":_vm.showActiveApi}},[_c('el-table-column',{attrs:{"prop":"name","label":"Name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticStyle:{"width":"56px","margin-right":"8px","text-align":"center"},attrs:{"size":"mini","effect":"plain","type":{
            GET: 'success',
            POST: 'warning',
            DELETE: 'danger',
            PUT: 'info',
          }[scope.row.method]}},[_vm._v(" "+_vm._s(scope.row.method)+" ")]),_vm._v(" "+_vm._s(scope.row.name)+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }